import Control from './control';
import TranscriberAPI from '../../transcriberApi';
import defaultsDeep from 'lodash-es/defaultsDeep';
import each from 'lodash-es/each';
import { updateClasses, getDefaultControl, buttonStyle } from './transcriber.defaults';
import uniqueId from '../uniqueId';
import merge from 'lodash-es/merge';
import getDefaultStyle from '../css/defaultStyle';
import updateStyle from '../css/updateStyle';
import lookAndFeel from '../lookAndFeel';
import updateStyleByRef from '../css/updateStyleByRef';
import frameProps from '../css/frameProps';
import {renderControls} from '../renderControls';



var icons = {
  start:"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath fill='%23FF0000' d='M19,12C19,15.86 15.86,19 12,19C8.14,19 5,15.86 5,12C5,8.14 8.14,5 12,5C15.86,5 19,8.14 19,12Z' /%3E%3C/svg%3E",
  started: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath fill='%23FF0000' d='M12,2A3,3 0 0,1 15,5V11A3,3 0 0,1 12,14A3,3 0 0,1 9,11V5A3,3 0 0,1 12,2M19,11C19,14.53 16.39,17.44 13,17.93V21H11V17.93C7.61,17.44 5,14.53 5,11H7A5,5 0 0,0 12,16A5,5 0 0,0 17,11H19Z' /%3E%3C/svg%3E",  
  send: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath fill='%23000000' d='M19.5 3.5L18 2L16.5 3.5L15 2L13.5 3.5L12 2L10.5 3.5L9 2L7.5 3.5L6 2L4.5 3.5L3 2V22L4.5 20.5L6 22L7.5 20.5L9 22L10.5 20.5L12 22V19.09H5V4.91H19V13.26L21 14.26V2L19.5 3.5M14 23V19L18 18L14 17V13L24 18L14 23M12 11V13H6V11H12M6 17V15H12V17H6M18 7V9H6V7H18Z' /%3E%3C/svg%3E",  
};



const defaultFrame = {
  position: 'absolute',
  display: 'block',
  overflow: 'hidden',
  top: '8px',
  left: '8px',
  width: '120px',
  height: '32px',
  userSelect: 'none',
}

export default class Transcriber extends Control {
  constructor(instance, path, nicePath) {
    super(instance, path, nicePath);    
    this._icons = {...icons};
  }

  onReady(){
    super.onReady();
    if(this.isLayoutMode) {return;}

    this.on('transcriberStart', (event, control, component) => {

      if(control.options.clearOnStart){
        control.previousValue = '';
        control.value = '';
      }else{
        control.previousValue = control.value;
      }

      component.getControl(control.id+'_start').showEffect();      
    });

    // not implemented
    // this.on('transcriberLevel', (event, control, component, anchor, data) => {
    //   // console.log('transcriberLevel');
    //   component.getControl(control.id+'_start').setEffectLevel(data[0]*1.2+0.2);
    // });

    this.on('transcriberStop,transcriberError', (event, control, component, anchor, data) => {
      component.getControl(control.id+'_start').hideEffect();
      component.getControl(control.id+'_start').setIsChecked(false);      
      component.getControl(control.id+'_start').setDisabled(false);
      const btSend = component.getControl(control.id+'_send')
      if(btSend){btSend.enable();}      
      
      if(event!='transcriberError'){
        control.doResetReload();        
      }else{
        console.log(data[0].message||data[0].error.message,data[0].error);
        control.render();
      }
    });

    this.on('transcriberText', (event, control, component, anchor, data) => {
      if(data[0].textFull){
        control.setValue(control.previousValue+' '+data[0].textFull);
      }else{
        control.setValue(control.getValue() + data[0].text);
      }

      control.doResetReload();
    });
  }

  getDefaults(){
    if(!this._defaults){
      this._defaults = {
        body:{
          style: {
            normal: {
              height: '48px',
              width: 'auto',
              display: 'inline-block',
              backgroundColor:'transparent'
            },
          },
          video:{
            enabled:true
          },
          buttons:{start:{}}
        },
        buttons:{
          start:{
            type: 'button',
            isToggle:true,               
            style: buttonStyle,
            icon: {
              url: this._icons.start,
              size:'80%'
            },
            iconActive: {
              url: this._icons.started
            },
            lookAndFeel: {
              background: '#ffffff'
            },
            classList:['no-layout'],
            effect:{
              repeat:'infinite',              
              style:{
                backgroundColor:'#FF0000',              
                boxShadow:'none',
                borderColor:'#FF0000',
                borderWidth:'0px'
              }
            },
            triggers: {
              click: function(eventId, control, component, anchor, data) {
                console.log('start');
                if(control.parentControl.transcriber.stopped){                  
                  control.parentControl.transcriber.start();
                }else{
                  control.disable();
                  control.parentControl.transcriber.end();
                }
              }
            }
          },

          send:{
            type: 'button',
            style: buttonStyle,
            icon: {
              url: this._icons.send,
              size:'80%'
            },
            lookAndFeel: {
              background: '#ffffff'
            },
            classList:['no-layout'],
            triggers: {
              click: function(eventId, control, component, anchor, data) {
                console.log('send');
                control.disable();
                control.parentControl.transcriber.send().then(function(){ 
                  control.enable(); 
                });
              }
            }
          },
        },            
      };
    }

    return this._defaults;
  }

  renderElement() {
    const control = this;
    const options = this._controlOptions;
    const instance = this.instance;
    const path = this.path;
    
    // console.log('renderElement', control, options, instance, path);
    defaultsDeep(options, this.getDefaults().body);

    if (!control.el) {
      control.el = getDefaultControl();
      if(!control.id){
        control.id = uniqueId(control.el, 'recharts-transcriber-',Transcriber);
        control.styleSheet = 'css-' + control.id;
        control.transcriber = new TranscriberAPI(control,'options');
      }else{
        control.el.setAttribute('id',control.id);
      }
    }



    defaultsDeep(options.buttons.start, this.getDefaults().buttons.start);

    options.buttons.start.name = control.id+'_start';    
    
    options.controls = [
      options.buttons.start,      
    ];

    if(options.buttons.send){
      defaultsDeep(options.buttons.send, this.getDefaults().buttons.send);

      options.buttons.send.name = control.id+'_send';
      options.controls.push(options.buttons.send);
    }
    

    updateClasses(control,options);
    
    // var bodyEl = control.el.getElementsByClassName('body')[0];
    

    var frameStylePatch = _.pick(merge({},getDefaultStyle(),defaultFrame, options.style.normal), frameProps);

    let scheme = lookAndFeel(options.lookAndFeel, options.style.normal.height);

    updateStyleByRef(frameStylePatch, scheme);
    updateStyle(control.el, frameStylePatch, control.currentFrameStyle);

    control.currentFrameStyle = frameStylePatch;
    
      each(options.controls, function(ctrl) {
        ctrl.lookAndFeel = merge({}, options.lookAndFeel, ctrl.lookAndFeel);
        if (!ctrl.style) {
          ctrl.style = {};
        }

        ctrl.style.normal = merge({}, ctrl.style.normal, {
          pointerEvents: 'auto',
        });
      });
      renderControls(instance, path,control.nicePath, control.el);

    return control.el;
  
  }

  toggle(event,me=this,cmp=me.instance,anchor,[ev]=[]){
    // console.log('starter:',event);
    const hit = ev===undefined
    || ev.target === me.el
    || ev.target === me.el.firstChild
    || ( me.options.attachTo!=='icon'
    && ( ev.target === me.parentControl.el
        ||ev.target === me.parentControl.el.firstChild)
    );
      
    if(hit){
      if(me.options.group){
        const current = me.instance.recorderGroups[me.options.group];
        if(current && current!==me.path){
          me.instance.controls[current].toggle(event=='click'&&event||'mouseleave');
        }
      }
    }

    if(event == 'clickOutside' || hit){

      if(event=='click'){
        me.showTranscriber = !me.showTranscriber;        
      }else if(event=='mouseenter'){
        me.showTranscriber = true;
        if(me.options.hideAfter){
          me._hideTimer = setTimeout(()=>{
            if(me.showTranscriber){
              me.showTranscriber=false;
              me.render();
              delete me._hideTimer;
            }
          },me.options.hideAfter*1000);
        }
      }else{
        if(event=='clickOutside'&&me.options.hideOnClickOutside
          ||event=='mouseleave'&&me.options.hideOnMoveOutside){

          me.showTranscriber = false;
          if(me._hideTimer){
             clearTimeout(me._hideTimer);
             delete me._hideTimer;
          }

        }
      }

      if(me.options.group){
        if(me.showTranscriber){
          me.instance.recorderGroups[me.options.group] = me.path;
        }else if(me.instance.recorderGroups[me.options.group] == me.path){
          me.instance.recorderGroups[me.options.group] = null;
        }
      }

      if(ev && event !== 'clickOutside') {ev.stopPropagation();}

      if(ev && event!=='mouseleave'){
        me.ev = ev;        
      }

      if(!me.showTranscriber){
        setTimeout(()=>{
          me.render();        
          me.raiseEvent('isExpanded',{value:me.showTranscriber,oldValue:!me.showTranscriber},ev);
        },100)
      }else{
        me.render();        
        me.raiseEvent('isExpanded',{value:me.showTranscriber,oldValue:!me.showTranscriber},ev);
      }
    }
  }
  

  
}
